import { FunctionComponent } from 'react';
import { TypeTextChildProps } from './types';
import { ListboxOption } from '@headlessui/react';
import { oneLine } from 'common-tags';

/**
 * Option
 */
export const Option: FunctionComponent<TypeTextChildProps> = ({
  className = '',
  value,
  children,
}: TypeTextChildProps) => (
  <ListboxOption
    className={({ active, selected }) => oneLine`
      relative cursor-pointer select-none px-4 py-3
      ${active || selected
        ? 'bg-primary-500 text-text-alternative'
        : 'bg-white text-text-primary'
      }
      ${className}
    `}
    value={{ value: value, label: children }}
  >
    {children}
  </ListboxOption>
);

Option.displayName = 'Option';
